import { DataGrid } from '@mui/x-data-grid';
import { useWatch } from 'react-hook-form';
import { select, tidy } from '@tidyjs/tidy';

import NET_ZERO_COLUMN, { NET_ZERO_VISIBILITY } from './NetZeroColumn';
import { useGetInfoCategoryMasterData } from '@Domains/MasterData';
import { INFO_CATEGORY_MASTER_DATA } from 'src/Enum/MasterData';
import { mapNetZeroToTable } from './utils';

const NetZeroTable = () => {
  const [{ data = [] }] = useGetInfoCategoryMasterData([
    INFO_CATEGORY_MASTER_DATA.CERTIFICATE_TGO,
    INFO_CATEGORY_MASTER_DATA.SBTI_GH_GAS_TARGET,
    INFO_CATEGORY_MASTER_DATA.GH_GAS_SCOPE,
  ]);

  const netZeroMasterData = tidy(data, select(['id', 'nameTh', 'nameEn']));
  const netZeroDetails =
    useWatch({
      name: 'greenhouseGoalTerm.netZero.details',
    }) || [];

  const mapNetZeroDetails = mapNetZeroToTable(
    netZeroDetails,
    netZeroMasterData
  );

  return (
    <DataGrid
      rows={mapNetZeroDetails ?? []}
      columns={NET_ZERO_COLUMN}
      getRowHeight={() => 'auto'}
      disableColumnSorting
      initialState={{
        columns: {
          columnVisibilityModel: NET_ZERO_VISIBILITY,
        },
      }}
    />
  );
};

export default NetZeroTable;
